// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"e1cffbb2","708":"91fd0260","732":"7a35a528"}[chunkId] + ".chunk.js";
};